import { render, staticRenderFns } from "./menuConent.vue?vue&type=template&id=c06c3438&scoped=true&"
import script from "./menuConent.vue?vue&type=script&lang=js&"
export * from "./menuConent.vue?vue&type=script&lang=js&"
import style0 from "./menuConent.vue?vue&type=style&index=0&id=c06c3438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06c3438",
  null
  
)

export default component.exports